// Calculate quality score for a single target
export const calculateTargetQuality = (target: { followers: string; posts: number }): number => {
  try {
    // Convert followers string to number
    const followers = parseInt(target.followers.replace(/[^0-9]/g, ''), 10);
    
    // Calculate follower score (0-1)
    let followerScore = 0;
    if (followers >= 2000 && followers <= 20000) {
      followerScore = 1;
    } else if (followers > 20000 && followers <= 25000) {
      // Gradually decrease score for followers above 20k
      followerScore = 1 - ((followers - 20000) / 5000);
    } else if (followers >= 1000 && followers < 2000) {
      // Gradually increase score for followers between 1k and 2k
      followerScore = (followers - 1000) / 1000;
    }

    // Calculate post score (0-1)
    let postScore = 0;
    if (target.posts >= 50) {
      postScore = 1;
    } else if (target.posts >= 25) {
      // Gradually increase score for posts between 25 and 50
      postScore = 0.5 + ((target.posts - 25) / 50);
    } else if (target.posts > 0) {
      // Small score for having any posts
      postScore = 0.1 + ((target.posts / 25) * 0.4);
    }

    // Calculate final score (0-100)
    const finalScore = Math.round((followerScore * 0.6 + postScore * 0.4) * 100);
    return Math.min(Math.max(finalScore, 0), 100);
  } catch (error) {
    console.error('Error calculating target quality:', error);
    return 0;
  }
};

// Get color based on quality score
export const getQualityColor = (score: number): { bg: string; text: string } => {
  if (score >= 80) {
    return { bg: 'bg-emerald-500', text: 'text-emerald-500' };
  } else if (score >= 60) {
    return { bg: 'bg-yellow-500', text: 'text-yellow-500' };
  } else if (score >= 40) {
    return { bg: 'bg-orange-500', text: 'text-orange-500' };
  }
  return { bg: 'bg-red-500', text: 'text-red-500' };
};